"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("../css/password_strength_item.css");

var _classnames = _interopRequireDefault(require("classnames"));

var _icon = _interopRequireDefault(require("./icon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PasswordStrengthItem = function PasswordStrengthItem(_ref) {
  var checked = _ref.checked,
      children = _ref.children,
      error = _ref.error,
      main = _ref.main,
      title = _ref.title;
  var itemClasses = (0, _classnames.default)({
    'vn-password-strength-item': true,
    'vn-password-strength-item--error': error
  });
  var statusClasses = (0, _classnames.default)({
    'vn-password-strength-item__status': true,
    'vn-password-strength-item__status--checked': checked,
    'vn-password-strength-item__status--error': error,
    'vn-password-strength-item__status--main': main
  });
  var status;

  if (checked) {
    status = _react.default.createElement(_icon.default, {
      name: "checkmark"
    });
  }

  if (error) {
    status = _react.default.createElement(_icon.default, {
      name: "remove"
    });
  }

  return _react.default.createElement("div", null, _react.default.createElement("div", {
    className: itemClasses
  }, _react.default.createElement("div", {
    className: statusClasses
  }, status), title), children && _react.default.createElement("div", {
    className: "vn-password-strength-item__sub-container"
  }, children));
};

PasswordStrengthItem.propTypes = {
  checked: _propTypes.default.bool,
  children: _propTypes.default.element,
  error: _propTypes.default.bool,
  main: _propTypes.default.bool,
  title: _propTypes.default.string
};
PasswordStrengthItem.defaultProps = {
  checked: false,
  children: undefined,
  error: false,
  main: false,
  title: undefined
};
PasswordStrengthItem.displayName = 'PasswordStrengthItem';
var _default = PasswordStrengthItem;
exports.default = _default;